<template>
  <div class="study-task-target">
    <template v-if="!inputted">
      <div class="desc" >
        {{ desc }}
      </div>
      <div class="btn">
        <button @click="pageAction">填写目标</button>
      </div>
    </template>
    <template v-else>
      <div class="desc">{{ desc }}</div>
    </template>
  </div>
</template>

<script setup>
import { defineProps, getCurrentInstance } from 'vue'
import Store from '@/public/utils/store'
import utils from '@utils/index'
import app from '@/widget/app'
import { hostPath } from '@utils/basePath'
const { proxy: { $router } } = getCurrentInstance()
const { currentRoute } = $router
const props = defineProps({
  desc: {
    type: String,
    default: ""
  },
  inputted: {
    type: Boolean,
    default: false
  },
  id: {
    type: Number,
    default: 0
  }
})

const pageAction = () => {
  Store.set(`target_${props.id}_desc`, props.desc, 'local')
  if (utils.isApp()) {
    app.postMessage({
      type: 'h5',
      url: `${hostPath}/learn/exercise/target?id=${props.id}&type=${currentRoute.value.query.type || 'OMO'}`
    })
  } else {
    $router.push(`/exercise/target?id=${props.id}&type=${currentRoute.value.query.type || 'OMO'}`)
  }
}

</script>

<style lang="scss" scoped>
.study-task-target {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
  }
  .btn {
    text-align: center;
    margin-top: 30px;
    button {
      display: inline-block;
      width: 176px;
      height: 72px;
      border-radius: 36px;
      border: none;
      color: #FF6600;
      font-size: 28px;
      background-color: #f5f5f5;
    }
  }
}
</style>
